// extracted by css-extract-rspack-plugin
export default {"component":"PopupHelper-module__component___YWtHe rfd-ui-popup-notification surveyeditor-PopupHelper"};